export function swapCase(input) {
    var result = "";
    for (var i = 0; i < input.length; i++) {
        var lower = input[i].toLowerCase();
        result += input[i] === lower ? input[i].toUpperCase() : lower;
    }
    return result;
}
//# sourceMappingURL=index.js.map